import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { confirmAlert } from 'react-confirm-alert';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';
import Title from 'shared/components/title/Title';
import SetHead from './SetHead';
import ExerciseItem from './ExerciseItem';

class WorkoutLogForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intialSets: props.values.series[props.seriesIndex].sets
    };
  }

  componentDidMount() {
    let { values, setFieldValue, seriesIndex } = this.props;
    let series = values.series;

    let isEditMood = Object.keys(
      series[seriesIndex].sets[0][`${series[seriesIndex].exercises[0].id}`]
    ).length;
    let currentSets = series[seriesIndex].sets.map(set => {
      return { ...set };
    });

    if (isEditMood) {
      setFieldValue('currentSets', currentSets);
    } else {
      let seriesReps = series[seriesIndex].reps;
      currentSets.forEach((set, setIndex) => {
        series[seriesIndex].exercises.forEach((exercise, exerciseIndex) => {
          set[`${exercise.id}`] = {
            weight: exercise.weight,
            reps: seriesReps
          };
        });
      });
      setFieldValue('currentSets', currentSets);
    }
  }

  handlelogcancelation = event => {
    let { setErrors } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure"
            text="you want to cancel?"
            cancelText="No"
            confirmText="Yes"
            onClose={onClose}
            handleConfirming={() => {
              setErrors({});
              this.props.backToLogSummery();
            }}
          />
        );
      }
    });
  };

  activateFormFields = () => {
    let { setFieldTouched, values, seriesIndex } = this.props;
    values.currentSets.forEach((set, setIndex) => {
      values.series[seriesIndex].exercises.forEach(exercise => {
        setFieldTouched(`currentSets[${setIndex}].${exercise.id}.weight`);
        setFieldTouched(`currentSets[${setIndex}].${exercise.id}.reps`);
      });
    });
  };

  handleSubmit = event => {
    let { values, setFieldValue, seriesIndex, errors, setErrors } = this.props;

    if (!Object.keys(errors).length) {
      setFieldValue(`series[${seriesIndex}].sets`, values.currentSets);
      setFieldValue('series.setsNum', values.currentSets.length);
      setErrors({});
      this.props.backToLogSummery(seriesIndex);
    }
  };

  handleAddSet = () => {
    let { values, setFieldValue, seriesIndex } = this.props;
    let { currentSets, series } = values;
    let newSet = {};

    series[seriesIndex].exercises.forEach((exercise, exerciseIndex) => {
      newSet[`${exercise.id}`] = {
        weight: exercise.weight,
        reps: series[seriesIndex].reps
      };
    });
    setFieldValue('currentSets', [...currentSets, { ...newSet }]);
  };

  handleDeleteSet = removedIndex => {
    let { values, setFieldValue, setErrors, errors } = this.props;
    let { currentSets } = values;
    let newCurrentSets = currentSets
      .slice(0, removedIndex)
      .concat(currentSets.slice(removedIndex + 1, currentSets.length));
    let currentSetsErrors =
      errors &&
      errors.currentSets &&
      errors.currentSets
        .slice(0, removedIndex)
        .concat(currentSets.slice(removedIndex + 1, errors.currentSets.length));
    setErrors({ ...currentSetsErrors });
    setFieldValue('currentSets', [...newCurrentSets]);
  };

  prepareSets = () => {
    let { values, seriesIndex } = this.props;
    let series = values.series[seriesIndex];

    return (values.currentSets || []).map((set, setIndex) => {
      return (
        <div>
          <SetHead
            key={`setHead${setIndex}`}
            title={`Set ${setIndex + 1} of ${values.currentSets.length}`}
            setIndex={setIndex}
            handleDeleteSet={this.handleDeleteSet}
            showDeleteIcon={values.currentSets.length > 1}
          />

          <ul>
            {series.exercises.map((exercise, exerciseIndex) => {
              return (
                <li key={exercise.id}>
                  <ExerciseItem
                    title={exercise.name}
                    desc={`Tempo ${exercise.tempo}, Rest ${
                      exercise.rest
                    }${exercise.rest_unit && exercise.rest_unit[0]}`}
                    setIndex={setIndex}
                    exercise={exercise}
                    seriesReps={series.reps || series.method}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      );
    });
  };

  render() {
    let { clientId, clientName, values, workoutName, seriesIndex } = this.props;

    let series = values.series[seriesIndex];
    return (
      <div className="workout-log">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href={`/clients/${clientId}`}>
              {clientName}
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={this.handlelogcancelation}>
              {workoutName}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{series.name}</Breadcrumb.Item>
          </Breadcrumb>

          <Title
            pageTitle={series.name}
            linkText="Cancel"
            buttonText="Save"
            cancelBtn={event => {
              event.preventDefault();
              this.handlelogcancelation();
            }}
            handleSubmit={event => {
              event.preventDefault();
              this.activateFormFields();
              this.handleSubmit();
            }}
          />

          <div className="workout-log-form">
            {this.prepareSets()}
            <div className="form-action">
              <button
                className="btn btn-primary"
                onClick={event => {
                  event.preventDefault();
                  this.handleAddSet();
                }}
              >
                <i className="fas fa-dumbbell"></i>
                Add Set
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WorkoutLogForm;
